import React, { useState } from 'react'

import { ImageLightBox, Text } from '@doist/marketist'

import { LazyImage } from 'components'

import css from './Figure.module.css'

export type FigureProps = {
    title: string
    href: string
    text?: string
    size?: { width: number; height: number }
}

export function Figure({ href, title, text, ...rest }: FigureProps) {
    const [showLightBox, setShowLightBox] = useState(false)
    const webpImageLink = href + '?fm=webp'
    return (
        <div className={css.figureContainer} {...rest}>
            <figure>
                <picture>
                    <LazyImage onClick={() => setShowLightBox(true)} src={href} alt={title} />
                </picture>
                {text && (
                    <Text tag="figcaption">
                        <p dangerouslySetInnerHTML={{ __html: text }} />
                    </Text>
                )}
            </figure>

            {showLightBox && (
                <ImageLightBox
                    src={href}
                    webp={webpImageLink}
                    onClose={() => {
                        setShowLightBox(false)
                    }}
                />
            )}
        </div>
    )
}
